module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0014.jpg?v=be74f0d8";